import React from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Skeleton,
  Typography,
} from "@mui/material";
import ComunityRadaria from "../../../../assets/images/ComunidadDeRadaria-Aux.webp";
import AddIcon from "@mui/icons-material/Add";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  getAllRunningsClubsAPI,
  joinRunningClubAPI,
} from "../../../../services/rest/runningsClubs/runningClubUser";
import {
  filterRunningClubDontUser,
  filterRunningClubOfuser,
} from "./filterRunningClubs";
import {
  setAllRunningsClubs,
  setRunningsClubsOfUser,
} from "../../../../redux/slice/runningsClubsSlice";
import { handleError } from "../../../../utils/handleError";

const InfoRunningClubUser = ({
  runningClub,
  ofUser,
  setOpen,
  galleryList,
  setLoading,
}) => {
  const { _id, status } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const joinRunningClub = async () => {
    try {
      if (status !== "active" || membershipStatus !== "active") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );

        return;
      }

      setLoading(true);
      // console.log("Id del running club", runningClub?._id);

      await joinRunningClubAPI(runningClub?._id);
      const getAll = await getAllRunningsClubsAPI();
      const runningsClubsOfUser = filterRunningClubOfuser(getAll, _id);
      const AllRunnningClubs = filterRunningClubDontUser(getAll, _id);
      dispatch(
        setAllRunningsClubs({ allRunningsClubs: AllRunnningClubs ?? [] })
      );
      dispatch(
        setRunningsClubsOfUser({ runningsClubsOfUser: runningsClubsOfUser })
      );
      setLoading(false);
      navigate("/dashboard/runnings-clubs/profile-club", {
        state: { runningClub: runningClub, ofUser: true },
      });
      toast.success(
        `Ahora puede ver las novedades de,${runningClub?.nameRunningClub}`
      );
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `¡Algo salió mal! \n
            ${message}`
      );
      // console.log("errror al unirme", error);

      setLoading(false);
    }
  };
  return (
    <Box sx={{ display: "flex", gap: 5 }}>
      <Box size={5}>
        <Box
          sx={{
            backgroundColor: "rgba(212, 216, 216, 0.32)",
            padding: 3,
            //   maxHeight: 500,
            maxWidth: 350,
            borderRadius: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Box sx={{ borderRadius: 5, overflow: "hidden", maxWidth: 250 }}>
            <img
              src={runningClub?.urlImg ?? ComunityRadaria}
              width={200}
              alt="imagen de galeria de club de corredores."
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {!ofUser ? (
              <Button
                variant="outlined"
                color="#e7ef7d"
                startIcon={<AddIcon />}
                onClick={() => joinRunningClub()}
              >
                Unirme
              </Button>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <IconButton onClick={() => setOpen(true)}>
                  <ReportProblemIcon sx={{ color: "#e7ef7d", fontSize: 36 }} />
                </IconButton>
                <IconButton
                  component="a"
                  href={runningClub?.urlInstagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon sx={{ color: "#e7ef7d", fontSize: 36 }} />
                </IconButton>
              </Box>
            )}
            {/* <Typography sx={{ textAlign: "center" }}>
              {runningClub?.description ??
                "Descripción de la club de corredores."}
            </Typography> */}
          </Box>
        </Box>
      </Box>
      <Box
        size={6}
        sx={{
          backgroundColor: "rgba(212, 216, 216, 0.32)",
          padding: 2,
          borderRadius: 5,
          width: "100%",
        }}
      >
        <Box
          sx={{
            height: "500px",
            width: "100%",
            overflowY: "auto",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center", // Centra el contenido horizontalmente
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              maxWidth: "1200px", // Opcional: establece un ancho máximo
              width: "100%", // Asegura que ocupe el ancho disponible
              justifyContent: "center", // Centra los items hijos
            }}
          >
            {/* Estado de carga */}
            {!galleryList ? (
              // Muestra 8 skeletons mientras carga
              galleryList.map((image) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={`skeleton-${image?._id}`}
                  sx={{
                    display: "flex",
                    justifyContent: "center", // Centra el contenido de cada Grid item
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: "#121212",
                      width: "100%",
                      maxWidth: "300px", // Opcional: limita el ancho máximo
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Skeleton
                      sx={{ bgcolor: "grey.900" }}
                      variant="rectangular"
                      width="100%"
                      height={200}
                    />
                  </Box>
                </Grid>
              ))
            ) : /* Cuando ya cargó pero no hay imágenes */
            galleryList && galleryList.length === 0 ? (
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" p={4}>
                  <Typography variant="body1" color="textSecondary">
                    No hay imágenes disponibles
                  </Typography>
                </Box>
              </Grid>
            ) : (
              /* Cuando hay imágenes */
              galleryList?.map((image, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center", // Centra el contenido de cada Grid item
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 1,
                      width: "100%",
                      maxWidth: "300px", // Opcional: limita el ancho máximo
                    }}
                  >
                    <img
                      src={image?.url || ComunityRadaria}
                      alt="Imagen de la club de corredores."
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoRunningClubUser;
